// LangLayout.jsx
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

export default function LangLayout() {
  const { lang } = useParams();
  const currentLang = lang === "en" ? "en" : "fa";
  const { i18n } = useTranslation();

  // direction و lang روی html
  useEffect(() => {
    document.documentElement.setAttribute(
      "dir",
      currentLang === "en" ? "ltr" : "rtl"
    );
    document.documentElement.setAttribute("lang", currentLang);
  }, [currentLang]);

  // همگام‌سازی i18next با URL
  useEffect(() => {
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }
  }, [currentLang, i18n]); // ← مهم

  if (lang !== "fa" && lang !== "en") return <Navigate to="/fa" replace />;
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}
